var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { mBody1, neutralDay } from '@teamsparta/design-system';
import { Device } from '../../../styles/_variables';
var Input = function (_a) {
    var value = _a.value, setValue = _a.setValue, placeHolder = _a.placeHolder, type = _a.type, isEmbedded = _a.isEmbedded, isWithButton = _a.isWithButton, maxLength = _a.maxLength, checkAlert = _a.checkAlert, onFocus = _a.onFocus, onBlur = _a.onBlur, isSingleChild = _a.isSingleChild, onClickCta = _a.onClickCta;
    var handleInput = function (e) {
        setValue(e.target.value);
        if (checkAlert)
            checkAlert();
    };
    var baseProps = {
        value: value,
        onChange: handleInput,
        onInput: handleInput,
        placeholder: placeHolder,
        isEmbedded: isEmbedded,
        isWithButton: isWithButton,
        type: type ? type : 'string',
        onFocus: function (e) {
            onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
        },
        onBlur: function (e) {
            onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
        },
    };
    var maxLengthProps = maxLength
        ? {
            maxLength: maxLength,
            onInput: function (e) {
                e.target.value = e.target.value.slice(0, Math.min(maxLength, e.target.value.length));
            },
        }
        : {};
    var numberTypeProps = type === 'number'
        ? {
            onWheel: function (e) { return e.currentTarget.blur(); },
        }
        : {};
    var focusNextInput = function (onClickCta) {
        var inputsArray = Array.from(document.querySelectorAll('.login-custom-input'));
        var focused = document.activeElement || inputsArray[0];
        var currentIndex = inputsArray.indexOf(focused);
        switch (currentIndex) {
            case -1:
                break;
            case inputsArray.length - 1:
                if (onClickCta)
                    onClickCta();
                break;
            default:
                try {
                    inputsArray[currentIndex + 1].focus();
                }
                catch (e) {
                    console.log(inputsArray[currentIndex + 1]);
                }
        }
    };
    var continueInput = function (e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            e.preventDefault();
            focusNextInput(onClickCta);
        }
    };
    return (_jsx(InputWrapper, __assign({}, baseProps, maxLengthProps, numberTypeProps, { autoCapitalize: 'off', isSingleChild: isSingleChild, onKeyDown: continueInput, onKeyUp: function () {
            checkAlert && checkAlert();
        }, className: 'login-custom-input' })));
};
export default Input;
var InputWrapper = styled.input(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: ", ";\n  flex-direction: row;\n  align-items: center;\n  box-sizing: border-box;\n  background: ", ";\n  border-radius: 8px;\n  outline: none;\n  border: none;\n  caret-color: ", ";\n  ", ";\n  color: ", ";\n  font-size: 14px;\n  width: ", ";\n  height: ", "px;\n  padding: ", ";\n\n  input:-internal-autofill-selected {\n    background-color: rgba(0, 0, 0, 0);\n  }\n\n  &::placeholder {\n    color: ", ";\n  }\n\n  // number type \uD654\uC0B4\uD45C \uC81C\uAC70\n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  &[type='number'] {\n    -moz-appearance: textfield;\n  }\n\n  ", " {\n    font-size: 16px;\n    padding: ", ";\n    height: ", "px;\n    color: ", ";\n    transform: scale(calc(14 / 16)) translate(calc(-100% / 16), calc(100% / 16));\n    width: ", ";\n    height: ", ";\n    margin-top: calc(-61px / 7);\n  }\n"], ["\n  display: ", ";\n  flex-direction: row;\n  align-items: center;\n  box-sizing: border-box;\n  background: ", ";\n  border-radius: 8px;\n  outline: none;\n  border: none;\n  caret-color: ", ";\n  ", ";\n  color: ", ";\n  font-size: 14px;\n  width: ", ";\n  height: ", "px;\n  padding: ", ";\n\n  input:-internal-autofill-selected {\n    background-color: rgba(0, 0, 0, 0);\n  }\n\n  &::placeholder {\n    color: ", ";\n  }\n\n  // number type \uD654\uC0B4\uD45C \uC81C\uAC70\n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  &[type='number'] {\n    -moz-appearance: textfield;\n  }\n\n  ", " {\n    font-size: 16px;\n    padding: ", ";\n    height: ", "px;\n    color: ", ";\n    transform: scale(calc(14 / 16)) translate(calc(-100% / 16), calc(100% / 16));\n    width: ", ";\n    height: ", ";\n    margin-top: calc(-61px / 7);\n  }\n"])), function (_a) {
    var isHidden = _a.isHidden;
    return (isHidden ? 'none' : 'flex');
}, neutralDay.gray0, neutralDay.gray100, mBody1, neutralDay.gray100, function (_a) {
    var isWithButton = _a.isWithButton;
    return (isWithButton ? '72%' : '100%');
}, function (_a) {
    var isEmbedded = _a.isEmbedded, isSingleChild = _a.isSingleChild;
    return (isEmbedded ? (isSingleChild ? 21 : 36) : 61);
}, function (_a) {
    var isEmbedded = _a.isEmbedded;
    return (isEmbedded ? '0' : '0 24px');
}, neutralDay.gray50, Device.Mobile, function (_a) {
    var isEmbedded = _a.isEmbedded;
    return (isEmbedded ? '0' : '0 20px');
}, function (_a) {
    var isEmbedded = _a.isEmbedded;
    return (isEmbedded ? 36 : 56);
}, neutralDay.gray100, function (_a) {
    var isWithButton = _a.isWithButton;
    return (isWithButton ? 'calc(100% * (16 / 14) - 100px)' : 'calc(100% * (16 / 14))');
}, function (_a) {
    var isEmbedded = _a.isEmbedded, isSingleChild = _a.isSingleChild;
    return "calc(".concat(isEmbedded ? (isSingleChild ? 21 : 36) : 61, "px*(16 / 14))");
});
var templateObject_1;
//# sourceMappingURL=Input.js.map